import { AfterContentInit, Component, OnInit, RendererFactory2 } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { EnvService } from '../../../core/services/env.service';
import { LocationService } from '../../../core/services/location.service';
import { MatomoTracker } from '@ngx-matomo/tracker';

@Component({
  selector: 'app-cookies-notification',
  templateUrl: './cookies-notification.component.html',
  styleUrls: ['./cookies-notification.component.scss'],
})
export class CookiesNotificationComponent implements OnInit, AfterContentInit {
  public showCookies = false;
  readonly COOKIE_NAME = 'CookieAccepted';
  public country: string;

  constructor(
    private cookieService: CookieService,
    private rendererFactory: RendererFactory2,
    protected env: EnvService,
    private locationService: LocationService,
    private matomo: MatomoTracker,
  ) {
    if (this.env.environment?.tag_url) this.loadTag();
  }

  ngOnInit() {
    this.locationService.country$.subscribe((country) => {
      this.country = country ?? 'US';
    });

    this.showCookies = !this.cookieService.check(this.COOKIE_NAME);
    this.matomo.requireCookieConsent();
  }

  ngAfterContentInit() {
    if (this.country === 'US') {
      this.accept(); // auto-accept within US
    }
  }

  public accept() {
    this.setCookies(true);
    this.showCookies = false;
    this.matomo.rememberConsentGiven();
  }

  public decline() {
    this.setCookies(false);
    this.showCookies = false;
    this.matomo.forgetConsentGiven();
  }

  private setCookies(isAccepted: boolean): void {
    this.cookieService.set(this.COOKIE_NAME, JSON.stringify(isAccepted), 30, '/', undefined, true);
  }

  private loadGtm() {
    const cookies = JSON.parse(
      this.checkCookiesValue(this.cookieService.get(this.COOKIE_NAME)) || 'false',
    );
    if (!cookies) return;

    const renderer = this.rendererFactory.createRenderer(null, null);
    const script = renderer.createElement('script');
    script.async = true;
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${this.env.environment.gtm_key}');`;

    renderer.appendChild(document.head, script);

    const div = document.createElement('div');
    div.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${this.env.environment.gtm_key}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    renderer.appendChild(document.body, div);
  }
  private loadTag() {
    const cookies = JSON.parse(
      this.checkCookiesValue(this.cookieService.get(this.COOKIE_NAME)) || 'false',
    );
    if (!cookies) return;

    const renderer = this.rendererFactory.createRenderer(null, null);
    const script = renderer.createElement('script');
    script.async = true;
    script.innerHTML = `
    var _mtm = window._mtm = window._mtm || [];
    _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
    (function() {
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.async=true; g.src='${this.env.environment.tag_url}'; s.parentNode.insertBefore(g,s);
    })();`;

    renderer.appendChild(document.head, script);
  }

  private checkCookiesValue(value: string) {
    if (value === 'false' || value === 'true') {
      return value;
    } else {
      this.cookieService.delete(this.COOKIE_NAME);
      return 'false';
    }
  }
}
